import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CircleDownloadFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM12.7 6.68H11.3V11.8L9.14 9.56L8.28 10.4L12 14.08L15.72 10.4L14.86 9.56L12.7 11.8V6.68ZM8.22 16.04H15.8V14.68H8.22V16.04Z" />
    </SvgIcon>
  );
});
